import { useMemo, useState } from "react";

import { OrganizationDetails } from "@organization/models/OrganizationDetails";

import { OrganizationContext } from "./OrganizationContext";

export const OrganizationContextProvider = ({
  children,
  initialOrganization = {} as OrganizationDetails
}) => {
  const [organization, setOrganization] =
    useState<OrganizationDetails>(initialOrganization);

  const contextValue = useMemo(
    () => ({
      organization: organization,
      setOrganization: setOrganization
    }),
    [organization]
  );

  return (
    <OrganizationContext.Provider value={contextValue}>
      {children}
    </OrganizationContext.Provider>
  );
};
